const KEY: string = 'impersonationuserid';

class ImpersonationStore {
    getUserImpersonationId = () => {
        return localStorage.getItem(KEY);
    };

    setUserImpersonationId = (userid: number) => {
        localStorage.setItem(KEY, userid + '');
    };

    clearUserImpersonationId = () => {
        localStorage.removeItem(KEY);
    };

    isImpersonated = () => {
        return localStorage.getItem(KEY) != null;
    };
}

export default new ImpersonationStore();
